import { QUERY_KEYS } from '../../../../../consts';
import { updatePatientService } from '../../../../../services';
import { getAtomWithMutation } from '../../../../../utils';

export const updatePatientAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.PATIENTS.UPDATE,
  mutationFn: () => updatePatientService,
});
